import { render, staticRenderFns } from "./pointerStatus.vue?vue&type=template&id=120d41d4&scoped=true"
import script from "./pointerStatus.vue?vue&type=script&lang=js"
export * from "./pointerStatus.vue?vue&type=script&lang=js"
import style0 from "./pointerStatus.vue?vue&type=style&index=0&id=120d41d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120d41d4",
  null
  
)

export default component.exports